module.exports = __webpack_public_path__ + "42050255c0225d748511d2496007a8da.webp";